import React from 'react'
import './index.css'

interface NoticeItemProps {
    time: string
    content: string
}

const NoticeItem: React.FC<NoticeItemProps> = (props) => {
    return (
        <div className='noticeItem'>
            <p className='noticeItemTime'>{props.time}</p>
            <p>{props.content}</p>
        </div>
    )
}

export default NoticeItem
